export default __webpack_public_path__ + "static/media/carousel1.29396488.png";